// extracted by mini-css-extract-plugin
export var emptyState = "_5r-d";
export var statCard = "_5r-c";
export var table = "_5r-0";
export var tableCell = "_5r-4";
export var tableCellClickable = "_5r-5 _5r-4";
export var tableCellDefault = "_5r-6 _5r-4";
export var tableCellEmpty = "_5r-8";
export var tableCellWithValue = "_5r-7";
export var tableContainer = "_5r-e";
export var tableHeaderWeight = "_5r-1";
export var tableHeaderZone = "_5r-2";
export var tableRowHeader = "_5r-3";
export var viewModeButton = "_5r-9";
export var viewModeButtonActive = "_5r-a _5r-9";
export var viewModeButtonInactive = "_5r-b _5r-9";